var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read-time font-text"},[_c('i',{staticClass:"fa-regular fa-clock"}),_vm._v(" "),_c('span',{staticClass:"read-time__minuets"},[_vm._v(_vm._s(_vm.formatReadMinuets)+" min ")])])}
var staticRenderFns = []

export { render, staticRenderFns }